import React from 'react'
import { components } from "react-select";
import PropTypes from 'prop-types';

const NoOptionMenuList = (props) => {
    return (
        <components.MenuList {...props} className="no-options">
            {props.children}
        </components.MenuList>
    )
}


NoOptionMenuList.propTypes = {
     children: PropTypes.node,
};

export default NoOptionMenuList
